var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepublicOfMacedonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95437 31.0455 6.10352e-05 19.9998 6.10352e-05C8.95412 6.10352e-05 -0.000183105 8.95437 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0416 39.7701C26.2944 39.2738 29.2887 37.9929 31.8273 36.128L20.0001 20L23.0416 39.7701Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9584 0.229919C13.7056 0.726169 10.7114 2.00711 8.17267 3.87187L20 20L16.9584 0.229919Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17267 36.128C10.7113 37.9928 13.7055 39.2738 16.9582 39.7702L20 20L8.17267 36.128Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87187 8.17267C2.00703 10.7114 0.726248 13.7056 0.229919 16.9584L20 20L3.87187 8.17267Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.229919 23.0416C0.726169 26.2944 2.00711 29.2886 3.87195 31.8272L20 20L0.229919 23.0416Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7701 16.9584C39.2738 13.7056 37.993 10.7114 36.1281 8.17273L20.0001 20L39.7701 16.9584Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8273 3.87179C29.2886 2.00703 26.2944 0.726169 23.0416 0.229919L20.0001 20L31.8273 3.87179Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1283 31.8273C37.993 29.2886 39.2739 26.2943 39.7703 23.0416L20.0001 20L36.1283 31.8273Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.9565C23.842 26.9565 26.9565 23.8419 26.9565 20C26.9565 16.158 23.842 13.0435 20 13.0435C16.158 13.0435 13.0435 16.158 13.0435 20C13.0435 23.8419 16.158 26.9565 20 26.9565Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 25.2174C22.8815 25.2174 25.2174 22.8815 25.2174 20C25.2174 17.1185 22.8815 14.7826 20 14.7826C17.1185 14.7826 14.7825 17.1185 14.7825 20C14.7825 22.8815 17.1185 25.2174 20 25.2174Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicOfMacedonia);
export default __webpack_public_path__ + "static/media/republic_of_macedonia.fc8170996dec01024b94c435c03fd877.svg";
export { ForwardRef as ReactComponent };